<template>
  <div v-if="ready">
    <SolicitacaoListagemHeader
      :rota-historico="rotaHistorico"
      :rota-novo="rotaNovo"
    />

    <ComponenteSolicitacaoListagem
      :funcionalidade="funcionalidade"
      :lista-externa="listaExterna"
      :chave-externa="chaveExterna"
      :lista-interna="listaInterna"
      :rota-historico="rotaHistorico"
      :quantidadeItens="configuracaoAcesso.meusProtocolos.parametros.quantidadeItensLista"
    >
      <template v-slot:externo="{card}">
        <slot
          :card="card"
        />
      </template>

      <template v-slot:interno="{card}">
        <div
          @click="detalhe(card)"
        >
          <ListaStatusCard
            :card="card"
          />
        </div>
      </template>
    </ComponenteSolicitacaoListagem>
  </div>
</template>

<script>
import ComponenteSolicitacaoListagem from '@/components/TemplateSolicitacao/componentes/ComponenteSolicitacaoListagem'
import ListaStatusCard from '@/components/TemplateSolicitacao/componentes/ListaStatusCard'
import SolicitacaoListagemHeader from '@/components/TemplateSolicitacao/componentes/SolicitacaoListagemHeader'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SolicitacaoListagemGeral',
  components: { SolicitacaoListagemHeader, ListaStatusCard, ComponenteSolicitacaoListagem },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    },
    rotaNovo: {
      type: String,
      defalut: ''
    },
    rotaDetalhe: {
      type: String,
      defalut: ''
    },
    rotaHistorico: {
      type: String,
      defalut: ''
    }
  },
  data () {
    return {
      listaInterna: [],
      ready: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiAcesso']),
    ...mapGetters('SetupApp', ['configuracaoAcesso'])
  },
  methods: {
    async init () {
      await this.getList()
    },
    detalhe (card) {
      return this.$router.push({
        path: this.rotaDetalhe,
        query: {
          idOcorrencia: card['id_ocorrencia']
        }
      })
    },
    async getList () {
      const response = await this.apiAcesso.meusProtocolos.lista({
        loading: true,
        handlerErrorIgnore: true
      })

      this.listaInterna = response.data.contratos
      this.ready = true
    },
    goToHistorico (contrato) {
      return this.$router.push({
        path: this.rotaHistorico,
        query: {
          numeroContrato: contrato.numeroContrato || 'n/a'
        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>

</style>
